if (!customElements.get('worth-it-first-perk')) {
  customElements.define('worth-it-first-perk', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      const controller = this._controller = new AbortController();
      const options = { signal: controller.signal };
      const current = () => this._controller === controller && !controller.signal.aborted && this.isConnected;
      const main = this.closest('product-info');
      const code = 'WORTHFIRST15';
      if (!main || this.dataset.enabled !== 'true' || this.dataset.mode !== 'repeating_cycle' || this.dataset.currency !== 'INR' || this.dataset.code !== code || !['guest', 'first'].includes(this.dataset.customerState)) { this.hidden = true; return; }
      const money = amount => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount / 100);
      const estimate = this.querySelector('[data-wi-perk-estimate]');
      const quantityNote = this.querySelector('[data-wi-perk-quantity-note]');
      const clock = this.querySelector('[data-wi-perk-clock]');
      const remaining = this.querySelector('[data-wi-perk-remaining]');
      const toggle = this.querySelector('[data-wi-perk-toggle]');
      const clockNote = this.querySelector('[data-wi-perk-clock-note]');
      const allocation = this.querySelector('[data-wi-perk-allocation]');
      const motion = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      const finishCelebration = () => this._celebration?.finish();
      const celebrateAccepted = () => {
        if (!current() || !this._acceptedForCelebration || this._celebrated || this.hidden || document.hidden || !motion || motion.matches || typeof Element.prototype.animate !== 'function') return;
        const badge = this.querySelector('.wi-first-perk__badge');
        if (!badge) return;
        const rect = badge.getBoundingClientRect();
        if (!badge.getClientRects().length || rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth || document.querySelector('cart-drawer.active, quick-add-modal[open], dialog[open]')) return;
        if (rect.top < 0 || rect.bottom > window.innerHeight || rect.left < 0 || rect.right > window.innerWidth) return;
        const header = document.querySelector('.wi-header');
        if (header && rect.top < header.getBoundingClientRect().bottom) return;
        const purchaseBar = document.querySelector('.wi-sticky-buy.is-visible');
        if (purchaseBar?.getClientRects().length && rect.bottom > purchaseBar.getBoundingClientRect().top) return;
        try { if (sessionStorage.getItem('worthit-perk-celebrated') === '1') return; } catch { /* The component guard still prevents repeated bursts. */ }
        this._celebrated = true;
        try { sessionStorage.setItem('worthit-perk-celebrated', '1'); } catch { /* No storage is needed to display the accepted discount. */ }
        const layer = document.createElement('span');
        layer.className = 'wi-first-perk__celebration';
        layer.setAttribute('aria-hidden', 'true');
        const animations = [];
        const finish = () => {
          clearTimeout(this._celebrationTimer);
          animations.forEach(animation => animation.cancel());
          layer.remove();
          if (this._celebration?.layer === layer) this._celebration = null;
        };
        this._celebration = { layer, finish };
        badge.appendChild(layer);
        this._celebrationTimer = setTimeout(finish, 900);
        try { for (let index = 0; index < 12; index += 1) {
          const piece = document.createElement('span');
          piece.className = 'wi-first-perk__piece';
          piece.style.background = index % 2 ? '#633599' : '#fff';
          layer.appendChild(piece);
          const angle = index / 11 * Math.PI;
          animations.push(piece.animate([
            { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
            { transform: `translate(${Math.cos(angle) * 33}px, ${-Math.sin(angle) * 50 - 10}px) rotate(${index * 29}deg)`, opacity: 0 }
          ], { duration: 700 + index * 10, easing: 'ease-out' }));
        } } catch { finish(); }
      };
      motion?.addEventListener?.('change', () => { if (motion.matches) finishCelebration(); }, options);
      const clearAllocation = () => {
        this._acceptedForCelebration = false;
        if (!allocation) return;
        allocation.dataset.state = 'pending';
        allocation.textContent = 'Enter WORTHFIRST15 at checkout. First-order eligibility and final savings are checked there.';
      };
      clearAllocation();
      const badge = this.querySelector('.wi-first-perk__badge');
      if (badge && typeof IntersectionObserver === 'function') {
        this._badgeObserver = new IntersectionObserver(celebrateAccepted);
        this._badgeObserver.observe(badge);
      }
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        this._cartLayerObserver = new MutationObserver(() => { if (cartDrawer.classList.contains('active')) finishCelebration(); else celebrateAccepted(); });
        this._cartLayerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('resize', celebrateAccepted, options);
      window.addEventListener('scroll', celebrateAccepted, { ...options, passive: true });
      let variants = [];
      try {
        const parsed = JSON.parse(this.querySelector('[data-wi-perk-variants]')?.textContent || 'null');
        if (Array.isArray(parsed) && parsed.every(v => v && /^\d+$/.test(String(v.id)) && Number.isSafeInteger(v.price) && v.price >= 0 && typeof v.available === 'boolean') && new Set(parsed.map(v => String(v.id))).size === parsed.length) variants = parsed;
      } catch { /* Invalid metadata never keeps an old estimate. */ }
      const updateEstimate = () => {
        if (!current()) return;
        const form = document.getElementById(this.dataset.formId);
        const owned = form && main.contains(form);
        const id = owned && form.querySelector('[name="id"]');
        let variant = id && variants.find(v => String(v.id) === id.value);
        const selected = main.querySelector('variant-selects [data-selected-variant]');
        if (selected) {
          try {
            const native = JSON.parse(selected.textContent);
            if (variant && native && String(native.id) === id?.value && Number.isSafeInteger(native.price) && native.price >= 0 && typeof native.available === 'boolean') variant = native;
            else variant = null;
          } catch { variant = null; }
        } else if (variants.length !== 1) variant = null;
        const input = owned ? (form.elements?.namedItem('quantity') || [...main.querySelectorAll('input[name="quantity"]')].find(q => q.form === form || q.getAttribute('form') === form.id)) : null;
        const quantity = input ? Number(input.value) : 1;
        const min = input ? Number(input.min || 1) : 1;
        const max = input?.hasAttribute('max') ? Number(input.max) : null;
        const step = input ? Number(input.step || 1) : 1;
        const quantityValid = !input?.disabled && input?.validity?.valid !== false && Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(min) && min > 0 && quantity >= min && Number.isSafeInteger(step) && step > 0 && (quantity - min) % step === 0 && (max === null || Number.isSafeInteger(max) && quantity <= max);
        const ready = !!(owned && id && !id.disabled && variant?.available && variant.price > 0 && !main.selectionUnconfirmed && !main.quantityRulesUnconfirmed && !main.nativeSubmitDisabled && !main.quantityUnavailable);
        const total = ready && quantityValid ? variant.price * quantity : NaN;
        const plan = owned && form.elements?.namedItem('selling_plan');
        const simpleVariant = ['selling_plan_allocations', 'quantity_price_breaks'].every(key => variant?.[key] === undefined || (Array.isArray(variant[key]) && variant[key].length === 0));
        const flatPricing = this.dataset.estimateAllowed === 'true' && /^\d+$/.test(this.dataset.productId || '') && this.dataset.productId === main.dataset.productId && !main.quantityPriceBreaksConfigured && (!plan || (typeof plan.value === 'string' && plan.value.trim() === '')) && simpleVariant;
        const valid = ready && quantityValid && flatPricing && Number.isSafeInteger(total) && total > 0;
        if (estimate) estimate.hidden = !valid;
        if (quantityNote) quantityNote.hidden = valid || this.dataset.estimateAllowed !== 'true';
        this.hidden = !ready;
        if (!valid || !estimate) return;
        // Integer-cent estimate, not a claim about Shopify's line allocation rounding.
        const discounted = Math.floor(total / 100) * 85 + Math.round(total % 100 * 85 / 100);
        if (!Number.isSafeInteger(discounted)) { estimate.hidden = true; if (quantityNote) quantityNote.hidden = false; return; }
        const label = estimate.querySelector('[data-wi-perk-estimate-label]');
        const before = estimate.querySelector('[data-wi-perk-current]');
        const after = estimate.querySelector('[data-wi-perk-price]');
        if (label) label.textContent = `${quantity} ${quantity === 1 ? 'pack' : 'packs'} · items estimate`;
        if (before) before.textContent = money(total);
        if (after) after.textContent = money(discounted);
      };
      main.addEventListener('input', updateEstimate, options);
      main.addEventListener('change', updateEstimate, options);
      this._observer = new MutationObserver(records => {
        if (records.some(record => record.target !== this && !this.contains(record.target))) updateEstimate();
      });
      this._observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value', 'min', 'max', 'step', 'class', 'aria-disabled'] });
      updateEstimate();

      // Only two timestamps and a hide preference are stored locally; no visitor identifier.
      const cycleKey = 'worth-it:first-perk:cycle:v1';
      const preferenceKey = 'worth-it:first-perk:clock-hidden:v1';
      const duration = 86400000;
      const minimum = 946684800000; // 1 January 2000; malformed clocks fail static.
      const maximum = 4102444800000; // 1 January 2100.
      const validWall = value => Number.isSafeInteger(value) && value >= minimum && value < maximum;
      const monotonic = () => typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance.now() : NaN;
      let record = null;
      let anchor = null;
      let clockFailed = false;
      let clockHidden = false;
      const stop = () => { clearInterval(this._timer); this._timer = null; };
      const staticClock = () => {
        stop(); anchor = null; clockFailed = true;
        if (clock) clock.hidden = true;
        if (remaining) remaining.textContent = '';
        if (toggle) toggle.hidden = true;
        if (clockNote) { clockNote.hidden = false; clockNote.textContent = 'The local clock is unavailable. Your first-order offer remains available; checkout checks eligibility.'; }
      };
      const saveRecord = wall => {
        if (!record || !validWall(wall) || wall < record.start || wall < record.lastSeen - 5000) throw new Error('Invalid local clock');
        record.lastSeen = Math.max(record.lastSeen, wall);
        const serialized = JSON.stringify(record);
        localStorage.setItem(cycleKey, serialized);
        if (localStorage.getItem(cycleKey) !== serialized) throw new Error('Unavailable clock storage');
      };
      const readRecord = wall => {
        if (!validWall(wall)) throw new Error('Unavailable local time');
        const saved = localStorage.getItem(cycleKey);
        if (saved === null) record = { start: wall, lastSeen: wall };
        else {
          const parsed = JSON.parse(saved);
          if (!parsed || !validWall(parsed.start) || !validWall(parsed.lastSeen) || parsed.start > wall || parsed.lastSeen < parsed.start || parsed.lastSeen > wall + 5000) throw new Error('Invalid persisted cycle');
          record = { start: parsed.start, lastSeen: parsed.lastSeen };
        }
        saveRecord(wall);
        clockHidden = localStorage.getItem(preferenceKey) === '1';
      };
      const tick = () => {
        if (!current() || document.hidden || clockHidden || clockFailed || !anchor || !record) { stop(); if (clock) clock.hidden = true; return false; }
        const now = Date.now();
        const mono = monotonic();
        const elapsed = mono - anchor.monotonic;
        if (!validWall(now) || !Number.isFinite(mono) || elapsed < 0 || mono < anchor.lastMonotonic || Math.abs(now - (anchor.wall + elapsed)) > 5000 || now < record.start || now < record.lastSeen - 5000) { staticClock(); return false; }
        anchor.lastMonotonic = mono;
        // Original local anchor stays unchanged, including after many 24-hour cycles.
        const seconds = Math.ceil((duration - ((now - record.start) % duration)) / 1000);
        const hours = Math.floor(seconds / 3600), minutes = Math.floor(seconds % 3600 / 60), rest = seconds % 60;
        if (remaining) remaining.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(rest).padStart(2, '0')}s`;
        if (clock) clock.hidden = false;
        return true;
      };
      const resume = () => {
        stop();
        if (!current() || document.hidden || clockFailed) { if (clock) clock.hidden = true; return; }
        try {
          const wall = Date.now(), mono = monotonic();
          if (!validWall(wall) || !Number.isFinite(mono) || mono < 0) throw new Error('Unavailable local clock');
          readRecord(wall);
          anchor = { wall, monotonic: mono, lastMonotonic: mono };
          if (clockNote) clockNote.hidden = true;
          if (toggle) { toggle.hidden = false; toggle.textContent = clockHidden ? 'Show clock' : 'Hide clock'; toggle.setAttribute('aria-expanded', String(!clockHidden)); }
          if (clock) clock.hidden = clockHidden;
          if (tick()) this._timer = setInterval(tick, 1000);
        } catch { staticClock(); }
      };
      const suspend = () => {
        stop(); if (clock) clock.hidden = true;
        if (clockFailed || !record) return;
        try { saveRecord(Date.now()); } catch { staticClock(); }
      };
      toggle?.addEventListener('click', () => {
        if (!current() || clockFailed || !record || !anchor) return;
        const wall = Date.now(), mono = monotonic();
        if (!validWall(wall) || !Number.isFinite(mono) || mono < anchor.lastMonotonic || Math.abs(wall - (anchor.wall + mono - anchor.monotonic)) > 5000) { staticClock(); return; }
        try { clockHidden = !clockHidden; localStorage.setItem(preferenceKey, clockHidden ? '1' : '0'); if (localStorage.getItem(preferenceKey) !== (clockHidden ? '1' : '0')) throw new Error('Unavailable preference'); saveRecord(wall); resume(); } catch { staticClock(); }
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) suspend(); else resume(); }, options);
      window.addEventListener('pagehide', suspend, options);
      window.addEventListener('pageshow', () => { updateEstimate(); resume(); refreshAllocation(); }, options);

      const status = this.querySelector('[data-wi-perk-status]');
      const copy = this.querySelector('[data-wi-perk-copy]');
      if (copy) { copy.hidden = true; copy.disabled = false; }
      if (copy && typeof navigator.clipboard?.writeText === 'function') {
        copy.hidden = false;
        copy.addEventListener('click', async () => {
          if (!current() || copy.disabled) return;
          copy.disabled = true;
          try { await navigator.clipboard.writeText(code); if (current() && status) status.textContent = 'Code copied. Checkout checks first-order eligibility and the actual discount.'; }
          catch { if (current() && status) status.textContent = 'The code could not be copied. Use the code link or enter WORTHFIRST15 at checkout.'; }
          finally { if (current()) copy.disabled = false; }
        }, options);
      }
      // Read-only native cart proof, never a cart mutation or fabricated success event.
      let endpoint = null;
      try {
        const route = window.Shopify?.routes?.root || '/';
        if (!/^\/(?:[^?#\\]*\/)?$/.test(route)) throw new Error('Invalid native route');
        const url = new URL(`${route}cart.js`, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Foreign cart route');
        endpoint = url;
      } catch { /* Keep acceptance pending when native proof cannot be read. */ }
      const refreshAllocation = () => {
        if (!current() || document.hidden || !endpoint) { clearAllocation(); return; }
        this._cartRequest?.abort();
        clearTimeout(this._cartDeadline);
        const request = this._cartRequest = new AbortController();
        clearAllocation();
        const fresh = () => current() && this._cartRequest === request && !request.signal.aborted && !document.hidden;
        this._cartDeadline = setTimeout(() => { if (this._cartRequest === request) { request.abort(); this._cartRequest = null; clearAllocation(); } }, 4000);
        Promise.resolve().then(() => fetch(endpoint.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', redirect: 'error', headers: { Accept: 'application/json' }, signal: request.signal }))
          .then(async response => {
            if (!fresh() || response.status !== 200 || response.redirected || new URL(response.url).origin !== endpoint.origin || new URL(response.url).pathname !== endpoint.pathname) throw new Error('Unconfirmed native cart');
            const cart = await response.json();
            if (!fresh() || cart?.currency !== 'INR' || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0 || !cart.items.every(item => typeof item.key === 'string' && item.key && Number.isSafeInteger(item.quantity) && item.quantity > 0) || new Set(cart.items.map(item => item.key)).size !== cart.items.length || cart.items.reduce((count, item) => count + item.quantity, 0) !== cart.item_count || !Number.isSafeInteger(cart.original_total_price) || cart.original_total_price < 0 || !Array.isArray(cart.cart_level_discount_applications)) throw new Error('Incomplete native cart');
            const matched = cart.cart_level_discount_applications.filter(app => app?.type === 'discount_code' && typeof app.title === 'string' && app.title.trim().toUpperCase() === code);
            const accepted = matched.length === 1 && Number.isSafeInteger(matched[0].total_allocated_amount) && matched[0].total_allocated_amount > 0 && matched[0].total_allocated_amount <= cart.original_total_price && cart.item_count > 0;
            if (allocation) {
              allocation.dataset.state = accepted ? 'accepted' : 'pending';
              allocation.textContent = accepted ? `${code} is applied in this cart: ${money(matched[0].total_allocated_amount)} off. Checkout rechecks first-order eligibility and the final total.` : 'Enter WORTHFIRST15 at checkout. First-order eligibility and final savings are checked there.';
            }
            this._acceptedForCelebration = accepted;
            if (accepted) celebrateAccepted();
          }).catch(() => { if (fresh()) clearAllocation(); })
          .finally(() => { if (this._cartRequest === request) { clearTimeout(this._cartDeadline); this._cartRequest = null; } });
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAllocation);
      document.addEventListener('visibilitychange', () => { if (document.hidden) { finishCelebration(); this._cartRequest?.abort(); this._cartRequest = null; clearTimeout(this._cartDeadline); clearAllocation(); } else refreshAllocation(); }, options);
      resume();
      refreshAllocation();
    }
    disconnectedCallback() {
      this._celebration?.finish();
      this._acceptedForCelebration = false;
      this._badgeObserver?.disconnect(); this._badgeObserver = null;
      this._cartLayerObserver?.disconnect(); this._cartLayerObserver = null;
      clearInterval(this._timer); this._timer = null;
      clearTimeout(this._cartDeadline);
      this._cartRequest?.abort(); this._cartRequest = null;
      this._unsubscribe?.(); this._unsubscribe = null;
      this._observer?.disconnect(); this._observer = null;
      this._controller?.abort(); this._controller = null;
    }
  });
}
